{
  "new-app-version-notification": {
    "buttons": {
      "update": "Aktualizace"
    },
    "text": {
      "new-version-available": "Nová verze je k dispozici"
    }
  }
}
